/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import AuthManager from "../../../Common/AuthManager";
import { AppContext } from "../../../Context/AppContext";
import Utils from "../../../Common/Utils";

const Sidebar = (props) => {
  const history = useHistory();
  const appData = useContext(AppContext);
  const goto = (url) => {
    history.push(url);
  };

  const get_username = () => {
    let userObj = null;

    if (AuthManager.isAuthenticated()) userObj = AuthManager.getAuthUser();
    if (
      userObj === null ||
      userObj === undefined ||
      userObj.profile === null ||
      userObj.profile === undefined
    )
      return "guest";

    return userObj.profile.first_name;
    // return userObj.profile.first_name + ' ' + userObj.profile.last_name;
  };

  React.useEffect(() => {
    Utils.run_initial_js();
  }, []);

  return (
    <React.Fragment>
      <div id="show-sidebar">
        <a id="show-sidebar-close" className="btn btn-sm btn-dark" href="#">
          <i className="fas fa-bars"></i>
        </a>
      </div>
      <nav id="sidebar" className="sidebar-wrapper">
        <div className="sidebar-content">
          <div className="sidebar-brand">
            <a href="#">GMS | Admin</a>

            <div id="close-sidebar">
              <i className="fas fa-times"></i>
            </div>
          </div>

          {/* <div className="sidebar-header">
            <div className="user-pic">
              <img
                className="img-responsive img-rounded"
                src="https://raw.githubusercontent.com/azouaoui-med/pro-sidebar-template/gh-pages/src/img/user.jpg"
                alt="Profile"
              />
            </div>
            <div className="user-info">
              <span className="user-name">
                <strong>
                  <a href="#" onClick={() => goto("/user/profile")}>
                    {get_username()}
                  </a>
                </strong>
              </span>
              
              <span className="user-status">
                <i className="fa fa-circle"></i>
                <span>Online</span>
              </span>
            </div>
          </div> */}

          <div className="sidebar-menu">
            <ul>
              {/* <li className="header-menu">
                <span>General</span>
              </li> */}

              <li className="sidebar">
                <a href="#" onClick={() => goto("/gms/dashboard")}>
                  <i className="fa fa-home" />
                  <span>GMS</span>
                </a>
              </li>

              <li className="sidebar">
                <a href="#" onClick={() => goto("/admin/dashboard")}>
                  <i className="fa fa-home"></i>
                  <span>Dashboard</span>
                </a>
              </li>

              <li className="sidebar-dropdown">
                <a href="#" onClick={() => goto("/admin/dashboard")}>
                  <i className="fa fa-bars"></i>
                  <span>Manage</span>
                </a>

                <div className="sidebar-submenu">
                  <ul>
                    <li>
                      <a
                        href="#"
                        onClick={() => goto("/admin/industry/manage")}
                      >
                        Industry
                      </a>
                    </li>
                    <li>
                      <a href="#" onClick={() => goto("/admin/party/list")}>
                        Party
                      </a>
                    </li>
                    {/* <li>
                      <a href="#" onClick={() => goto("/admin/logs")}>
                        User Logs
                      </a>
                    </li> */}
                    {/* <li>
                      <a
                        href="#"
                        onClick={() => goto("/admin/versionmanagement/list")}
                      >
                        VM Queries
                      </a>
                    </li> */}
                    {/* <li>
                      <a
                        href="#"
                        onClick={() => goto("/admin/reports/dashboard")}
                      >
                        Reports
                      </a>
                    </li> */}
                  </ul>
                </div>
              </li>
              <li className="sidebar">
                <a href="#" onClick={() => goto("/admin/reports/dashboard")}>
                  <i className="fa fa-tachometer-alt" />
                  <span>Reports</span>
                </a>
              </li>
              <li className="sidebar">
                <a
                  href="#"
                  onClick={() => goto("/admin/versionmanagement/list")}
                >
                  <i className="fa fa-layer-group" />
                  <span>Version Manager</span>
                </a>
              </li>
              <li className="sidebar">
                <a href="#" onClick={() => goto("/admin/logs")}>
                  <i className="fa fa-clipboard"></i>
                  <span>User Logs</span>
                </a>
              </li>
              <li className="sidebar">
                <a href="#" onClick={() => goto("/admin/task/queue/info")}>
                  <i className="fa fa-clipboard"></i>
                  <span>Task Queue</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="sidebar-footer">
          <a href="#">
            <i className="fa fa-bell"></i>
            <span className="badge badge-pill badge-warning notification"></span>
          </a>
          <a href="#">
            <i className="fa fa-envelope"></i>
            <span className="badge badge-pill badge-success notification"></span>
          </a>
          <a href="#">
            <i className="fa fa-cog"></i>
            <span className="badge-sonar"></span>
          </a>
          <a href="#" onClick={() => goto("/logout")}>
            <i className="fa fa-power-off"></i>
          </a>
        </div>
      </nav>
    </React.Fragment>
  );
};

export default Sidebar;
